import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'reactstrap';

import InfoHeader from './InfoHeader';
import RoomsVisualList from '../RoomsManager/RoomsVisualList';
import PaxesVisualList from '../PaxesManager/VisualList';
import InfoAmount from './InfoAmount';

const VisualMode = (props) => {
  const [liteRoomsList, setLiteRoomsList] = useState([]);
  const [litePaxesList, setLitePaxesList] = useState([]);

  useEffect(() => {
    const { reservation, availableRoomsList } = props;
    const { rooms } = reservation;

    if(!rooms) {
      setLiteRoomsList([]);
      setLitePaxesList([]);
      return;
    }

    const roomsListReduce = {};
    rooms.forEach((room) => {
      const { roomCode, paxes } = room;

      roomsListReduce[roomCode] = (roomsListReduce[roomCode] || 0) + 1;

      setLitePaxesList((litePaxesList) => [...litePaxesList, paxes[0]]);
    });

    Object.keys(roomsListReduce).forEach((roomCode) => {
      const roomCount = roomsListReduce[roomCode];
      const fullRoom = availableRoomsList.find(room => (room.code === roomCode));
      const roomName = (fullRoom && fullRoom.name) ? fullRoom.name : roomCode;

      const roomData = { code: roomCode, name: roomName, count: roomCount };

      setLiteRoomsList((liteRoomsList) => [...liteRoomsList, roomData]);
    });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const { reservation, firstValorate, handleMode } = props;

  const {
    id,
    locator,
    status,
    fromDate,
    toDate,
    amount,
    currencyCode,
    valorated,
    modified
  } = reservation;

  const customProps = (firstValorate) ? { isVisible: valorated } : {};

  return (
    <div onClick={handleMode}>
      <Row className="auto-margin">
        <Col sm="6" className="no-padding-left info-header">
          <InfoHeader
            locator={locator}
            identifier={id}
            status={status}
            modified={modified}
            valorated={valorated}
          />
        </Col>
        <Col sm="6" className="booking-info">
          {fromDate} | {toDate}
        </Col>
      </Row>
      <Row className="auto-margin reservation-data__container">
        <Col sm="5" className="no-padding">
          <RoomsVisualList
            roomsList={liteRoomsList}
            showIcon={true}
          />
        </Col>
        <Col sm="5" className="no-padding-right">
          <PaxesVisualList
            paxesList={litePaxesList}
            showIcon={true}
          />
        </Col>
        <InfoAmount
          {...customProps}
          amount={amount}
          currencyCode={currencyCode}
          colSize={2}
        />
      </Row>
    </div>
  );
};

VisualMode.propTypes = {
  reservation: PropTypes.object.isRequired,
  firstValorate: PropTypes.bool,
  availableRoomsList: PropTypes.arrayOf(PropTypes.object),
  handleMode: PropTypes.func
};

VisualMode.defaultProps = {
  firstValorate: false,
  availableRoomsList: [],
  handleMode: () => {}
};

export default VisualMode;
